const getEnv = () => {
  try {
    return process.browser
      ? window.STV.environment
      : process.env.STV_ENV
  } catch (error) {
    console.error(error) // eslint-disable-line
    return 'production'
  }
}

export default getEnv

export const HOST = (() => {
  switch (getEnv()) {
    case 'staging': return 'stvqa.tv'
    case 'development': return 'stvqa.tv'
    case 'testing': return 'stv.localhost:3000'
    default: return 'stv.tv'
  }
})()
